import React, { useReducer, createContext, useEffect } from 'react'
import ReactGA from 'react-ga'


const initialState = {
    discovery: {
        isSaytModalOpen: false,
        isSearchModalOpen: false
    },
    account: {
        isAccountDropdownOpen: false
    },
    email: {
        isEmailSignupModalOpen: false
    },
    loyalty: {
        isLoyaltySignupModalOpen: false
    },
    nonBeta: {
        isLoyaltyNonBetaModalOpen: false
    },
    garage: {
        isGarageModalOpen: false,
        isYmmModalOpen: false,
        isGarageDropdownOpen: false,
        market: 'street' // this gets used on the ymm modal to say what tab is opened, TNG cant do this out right. Micro frontends can remove this
    },
    controlBar: {
        isMenuActive: false,
        isShopActive: false,
        isGarageActive: false,
        isAccountActive: false,
        isCartActive: false
    },
    drawer: {
        isDrawerOpen: false,
        navigation: [{ component: 'PrimaryNavigation', menu: 'mainMenu' }],
        prerenderedNavigation: [{ component: 'SecondaryNavigation', menu: 'shopParts' }]
    },
    pageType: null
}

const NavigationReducer = (state, action) => {
    let calculatePageType = action?.payload?.pageType ? action?.payload?.pageType : state.pageType;
    switch (action.type) {
        case 'setPageType':
            const { pageType } = action.payload
            return { ...state, pageType: calculatePageType }
        case 'setAccountState':
            const { accountState } = action.payload
            ReactGA.event({
                category: 'Header',
                action: 'Account Dropdown Opened'
            })
            return { ...initialState, account: accountState, pageType: calculatePageType }
        case 'setEmailState':
            const { emailState } = action.payload
            const { isEmailSignupModalOpen } = emailState
            if (isEmailSignupModalOpen && !state?.drawer?.isDrawerOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'Email Signup Modal Opened'
                })
            }

            // dont open if drawer is open, return prev state
            if (state?.drawer?.isDrawerOpen || state?.discovery?.isSaytModalOpen) {
                return {
                    ...state,
                    email: { ...initialState.email },
                    pageType: calculatePageType
                }
            }

            return {
                ...initialState,
                email: { ...initialState.email, ...emailState },
                pageType: calculatePageType
            }
        case 'setIosInstallPromptState':
            const { iosInstallpromptState } = action.payload
            return {
                ...initialState,
                iosInstallpromptState,
                pageType: calculatePageType
            }
        case 'setLoyaltyState':
            const { loyaltyState } = action.payload
            const { isLoyaltySignupModalOpen } = loyaltyState
            if (isLoyaltySignupModalOpen && !state?.drawer?.isDrawerOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'Loyalty Signup Modal Opened'
                })
            }

            // dont open if drawer is open, return prev state
            if (state?.drawer?.isDrawerOpen || state?.discovery?.isSaytModalOpen) {
                return {
                    ...state,
                    loyalty: { ...initialState.loyalty },
                    pageType: calculatePageType
                }
            }

            return {
                ...initialState,
                loyalty: { ...initialState.loyalty, ...loyaltyState },
                pageType: calculatePageType
            }
        case 'setNonBetaState':
            const { nonBetaState } = action.payload
            const { isLoyaltyNonBetaModalOpen } = nonBetaState
            if (isLoyaltyNonBetaModalOpen && !state?.drawer?.isDrawerOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'Loyalty No-Beta Modal Opened'
                })
            }

            // dont open if drawer is open, return prev state
            if (state?.drawer?.isDrawerOpen) {
                return {
                    ...state,
                    nonBeta: { ...initialState.nonBeta },
                    pageType: calculatePageType
                }
            }

            return {
                ...initialState,
                nonBeta: { ...initialState.nonBeta, ...nonBetaState },
                pageType: calculatePageType
            }
        case 'setDiscoveryState':
            const { discoveryState } = action.payload
            const { isSaytModalOpen } = discoveryState
            if (isSaytModalOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'Sayt Modal Opened'
                })
            }
            const newState = { ...initialState.discovery, ...discoveryState }
            return {
                ...initialState,
                discovery: newState,
                pageType: calculatePageType
            }


        case 'setGarageState':
            const { garageState } = action.payload
            const {
                isGarageModalOpen,
                isYmmModalOpen,
                isGarageDropdownOpen,
            } = garageState

            if (isGarageModalOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'Garage Modal Opened'
                })
                return {
                    ...initialState,
                    garage: { ...initialState.garage, ...garageState },
                    controlBar: {
                        ...initialState.controlBar,
                        isGarageActive: true
                    },
                    pageType: calculatePageType
                }
            } else if (isYmmModalOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'YMM Modal Opened'
                })

            } else if (isGarageDropdownOpen) {
                ReactGA.event({
                    category: 'Header',
                    action: 'Garage Dropdown Opened'
                })
            }

            return {
                ...initialState,
                garage: { ...initialState.garage, ...garageState },
                pageType: calculatePageType
            }

        case 'setDrawerState':
            const { drawerAction, drawerState } = action.payload
            if (drawerAction) {
                return DrawerReducer(state, action)
            }
            return {
                ...initialState,
                drawer: { ...initialState.drawer, ...drawerState },
                pageType: calculatePageType
            }

        case 'setControlBarState':
            const { controlBarState } = action.payload
            return {
                ...state,
                controlBar: { ...initialState.controlBar, ...controlBarState },
                pageType: calculatePageType
            }
        default:
            return state
    }
}



const DrawerReducer = (state, action) => {
    const { drawerAction, drawerState } = action.payload
    switch (drawerAction.type) {
        case 'resetNavigation':
            return {
                ...initialState,
                drawer: { ...initialState.drawer, ...drawerState },
                controlBar: { ...initialState.controlBar, isMenuActive: true }
            }
        case 'gotoShopNavigation': {
            const navigation = [...initialState.drawer.navigation]
            navigation.push({
                component: 'SecondaryNavigation',
                menu: 'shopParts'
            })
            return {
                ...initialState,
                drawer: { ...initialState.drawer, ...drawerState, navigation },
                controlBar: { ...initialState.controlBar, isShopActive: true }
            }
        }
        case 'addNavigation': {
            const navigation = [...state.drawer.navigation]
            const addedNavigation = drawerAction.payload
            navigation.push(addedNavigation)
            return {
                ...initialState,
                drawer: { ...initialState.drawer, ...drawerState, navigation }
            }
        }
        case 'dropNavigation': {
            const navigation = [...state.drawer.navigation]
            navigation.pop()
            return {
                ...initialState,
                drawer: { ...initialState.drawer, ...drawerState, navigation }
            }
        }
        default:
            return state
    }
}
console.log('initial state', initialState)
const NavigationContext = createContext(initialState)

const NavigationProvider = ({ children, customState }) => {
    var [state, dispatch] = useReducer(NavigationReducer, initialState)

    const setYmmModal = (isOpen) => {

        dispatch({
            type: 'setGarageState',
            payload: {
                garageState: {
                    isYmmModalOpen: isOpen,
                    market: state.garage.market
                }
            }
        })

    }

    const setSearch = (isOpen = true) => {

        dispatch({
            type: 'setDiscoveryState',
            payload: {
                discoveryState: {
                    isSearchModalOpen: isOpen,
                }
            }
        })

    }

    const setPageType = (type) => {

        dispatch({
            type: 'setPageType',
            payload: {
                pageType: type ?? null
            }
        })

    }

    useEffect(() => {
        //reset pagetype on load until mfe sets it
        setPageType(null)
    }, [])

    return (
        <NavigationContext.Provider value={{ state: { ...state, ...customState }, dispatch, setYmmModal, setPageType, setSearch }}>
            {children}
        </NavigationContext.Provider>
    )
}

export { NavigationProvider, NavigationContext }
